import React, { useState, useRef } from "react";
import TestimonialIcon from "../icons/TestimonialIcon";
import "./Carousel.css"

function Carousel ({ components }) {
    const [activeIndex, setActiveIndex] = useState(0);
    const total = components.length;
    const startX = useRef(0);
    const isDragging = useRef(false);

    const handleMouseDown = (e) => {
        isDragging.current = true;
        startX.current = e.clientX;
    };

    const handleMouseMove = (e) => {
        if (!isDragging.current) return;
        const diff = e.clientX - startX.current;

        if (diff > 50) {
            setActiveIndex((prev) => (prev - 1 + total) % total);
            isDragging.current = false;
        } else if (diff < -50) {
            setActiveIndex((prev) => (prev + 1) % total);
            isDragging.current = false;
        }
    };

    const handleMouseUp = () => {
        isDragging.current = false;
    };

    const getPositionClass = (index) => {
        if (index === activeIndex) return "active";
        if (index === (activeIndex - 1 + total) % total) return "prev";
        if (index === (activeIndex + 1) % total) return "next";
        return "hidden";
    };

    const handleClick = (index) => {
        setActiveIndex(index);
    };

    return (
        <div className="carousel-wrapper" onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseUp}
            onTouchStart={(e) => handleMouseDown(e.touches[0])}
            onTouchMove={(e) => handleMouseMove(e.touches[0])}
            onTouchEnd={handleMouseUp}>
            {components.map((item, index) => (
                <div
                    key={index}
                    className={`carousel-testimonial ${getPositionClass(index)}`}
                    onClick={() => handleClick(index)}
                >
                    <TestimonialIcon />

                    <p>{item.description}</p>
                    <img src={item.image} alt={item.name} />
                    <p style={{ fontWeight: '600', fontSize: '16px' }}>{item.name}</p>
                    <small>{item.company}</small>
                </div>
            ))}
        </div>
    );

}

export default Carousel;
